/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FocusGroup,
  FocusGroupDetails,
  FocusGroupDetailsContent,
} from '../models/index';
import {
    FocusGroupFromJSON,
    FocusGroupToJSON,
    FocusGroupDetailsFromJSON,
    FocusGroupDetailsToJSON,
    FocusGroupDetailsContentFromJSON,
    FocusGroupDetailsContentToJSON,
} from '../models/index';

export interface AttendGroupRequest {
    groupId?: string;
}

export interface GetGroupDetailsRequest {
    groupId?: string;
}

export interface GroupDetailsRequest {
    groupId?: string;
}

/**
 * 
 */
export class ProgrammeGroupApi extends runtime.BaseAPI {

    /**
     */
    async allGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FocusGroup>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ProgrammeGroup/AllGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FocusGroupFromJSON));
    }

    /**
     */
    async allGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FocusGroup>> {
        const response = await this.allGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async attendGroupRaw(requestParameters: AttendGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.groupId !== undefined) {
            queryParameters['groupId'] = requestParameters.groupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ProgrammeGroup/AttendGroup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async attendGroup(requestParameters: AttendGroupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.attendGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGroupDetailsRaw(requestParameters: GetGroupDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FocusGroupDetailsContent>> {
        const queryParameters: any = {};

        if (requestParameters.groupId !== undefined) {
            queryParameters['groupId'] = requestParameters.groupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ProgrammeGroup/GetGroupDetails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FocusGroupDetailsContentFromJSON(jsonValue));
    }

    /**
     */
    async getGroupDetails(requestParameters: GetGroupDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FocusGroupDetailsContent> {
        const response = await this.getGroupDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async groupDetailsRaw(requestParameters: GroupDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FocusGroupDetails>> {
        const queryParameters: any = {};

        if (requestParameters.groupId !== undefined) {
            queryParameters['groupId'] = requestParameters.groupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ProgrammeGroup/GroupDetails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FocusGroupDetailsFromJSON(jsonValue));
    }

    /**
     */
    async groupDetails(requestParameters: GroupDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FocusGroupDetails> {
        const response = await this.groupDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async programmeHasAvailableGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ProgrammeGroup/ProgrammeHasAvailableGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async programmeHasAvailableGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.programmeHasAvailableGroupsRaw(initOverrides);
        return await response.value();
    }

}
